import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=3b376160&scoped=true&"
import script from "./Play.vue?vue&type=script&lang=ts&"
export * from "./Play.vue?vue&type=script&lang=ts&"
import style0 from "./Play.vue?vue&type=style&index=0&id=3b376160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b376160",
  null
  
)

export default component.exports